import React from 'react';
import ActionBar from './ActionBar';
import ExtractedItems from './ExtractedItems';
import FileViewer from './FileViewer';
import './ResultsView.css';
import SelectedProducts from './SelectedProducts';

const ResultsView = ({ 
  extractionData,
  selectedFileIndex,
  onFileSelect,
  selectedProducts,
  onRemoveSelection,
  onClearAllSelections,
  onSubmitOrder,
  currentExtraction,
  handleShowHistory,
  handleShowContext,
  handleShowReprocess,
  isReprocessing,
  getStatusLabel,
  showSidebar,
  onNewExtraction
}) => {
  return (
    <div className="results-view-container">
      <ActionBar
          extraction={currentExtraction}
          onShowHistory={handleShowHistory}
          onShowContext={handleShowContext}
          onShowReprocess={handleShowReprocess}
          isReprocessing={isReprocessing}
          getStatusLabel={getStatusLabel}
          showSidebar={showSidebar}
          onNewExtraction={onNewExtraction}
        />
        <div className="results-view">

        {/* Left Column - Files */}
        <div className="files-column">
          <FileViewer 
            files={extractionData?.filesUrls || []}
            onFileSelect={onFileSelect}
            selectedFileIndex={selectedFileIndex}
          />
        </div>

        {/* Middle Column - Extracted Items */}
        <div className="items-column">
          <ExtractedItems
            items={extractionData?.extractedOrderItems || []}
          />
        </div>

        {/* Right Column - Selected Products */}
        <div className="products-column">
          <SelectedProducts
            selectedProducts={selectedProducts}
            onRemoveSelection={onRemoveSelection}
            onClearAllSelections={onClearAllSelections}
            onSubmitOrder={onSubmitOrder}
          />
        </div>
        </div>
    </div>
    
  );
};

export default ResultsView;
